import './BooleanToggleField.css';

import React from 'react';
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import FieldComponent from './FieldComponent';
import { generateClassName, getValueAtPath, handleObjectFieldChange } from './helpers';

const BooleanToggleField = ({ label, field, object, setObject, className = null, trueIcon = CheckBox, falseIcon = CheckBoxOutlineBlank }) => {
    const handleToggle = () => {
        const currentValue = getValueAtPath(object, field);
        handleObjectFieldChange(field, !currentValue, setObject);
    };

    const currentValue = getValueAtPath(object, field);
    const TrueIconComponent = trueIcon;
    const FalseIconComponent = falseIcon;

    return (
        <FieldComponent
            label={label}
            component={
                <div
                    onClick={handleToggle}
                    style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
                    className='boolean-toggle-checkbox'
                >
                    {currentValue ? <TrueIconComponent /> : <FalseIconComponent />}
                </div>
            }
            className={generateClassName('boolean-toggle','-container',className)}
        />
    );
};

export default BooleanToggleField;